module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title_media":"フォト/ ビデオの添付","title_image":"写真の添付","add_image":"写真の添付","add_video":"ビデオの添付","disclaimer":"個人情報露出(CCTVブラックボックス)、名誉毀損、著作権などの権利侵害動画は利用約款及び関連法律により制裁を受けることがあります。"}}')
  delete Component.options._Ctor
}
